"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrustOrSmsfCompanyTrusteeSchema = exports.ACN_MATCHES = exports.ACN_LENGTH = exports.ACN_REQUIRED = exports.COMPANY_NAME_REQUIRED = exports.COMPANY_TYPE_REQUIRED = exports.LEGAL_ENTITY_NAME_REQUIRED = void 0;
const yup = __importStar(require("yup"));
const MyStakeAddress_1 = require("./MyStakeAddress");
const Contact_1 = require("./Contact");
const Abn_1 = require("./commons/Abn");
exports.LEGAL_ENTITY_NAME_REQUIRED = "Please enter the trust name";
exports.COMPANY_TYPE_REQUIRED = "Please select company type";
exports.COMPANY_NAME_REQUIRED = "Please select company name";
exports.ACN_REQUIRED = "Please enter the ACN";
exports.ACN_LENGTH = "ACN should be 9 characters";
exports.ACN_MATCHES = "ACN should contain only digits";
exports.TrustOrSmsfCompanyTrusteeSchema = yup
    .object()
    .shape({
    legalEntityName: yup.string().required(exports.LEGAL_ENTITY_NAME_REQUIRED),
    abn: Abn_1.abnOptional,
    companyName: yup.string().required(exports.COMPANY_NAME_REQUIRED),
    companyType: yup.string().required(exports.COMPANY_TYPE_REQUIRED),
    acn: yup.string().required(exports.ACN_REQUIRED).length(9, exports.ACN_LENGTH).matches(/^\d*$/, exports.ACN_MATCHES),
    legalEntityAddresses: yup.array().of(yup.object().shape(Object.assign({}, MyStakeAddress_1.MyStakeAddressSchema))),
    contacts: yup.array().of(yup.object().shape(Object.assign({}, Contact_1.ContactSchema))),
});
//# sourceMappingURL=TrustOrSmsfCompanyTrustee.js.map